import React, { useState } from 'react';
import { Input, Button } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MultiSelectWithOption from '../../molecules/MultiSelectWithOption';

const Title = styled.h3`
  margin-bottom: 24px;
`;

const InputWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

const InputInfo = styled.span`
  margin-top: 6px;
  color: #a3a4a5;
`;

const ActionButton = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 32px;

  button {
    margin-left: 16px;
  }
`;

function CreateNotification({ onPreview, onCreate, loading }) {
  const [notification, setNotification] = useState({ usersType: [] });

  const create = async () => {
    await onCreate(notification);
    setNotification({ usersType: [] });
  };

  const canCreate = () => {
    if (!notification.titulo || !notification.mensagem) return false;
    if (!notification.usersType || !notification.usersType.length) return false;
    return true;
  };

  return (
    <>
      <Title>Criar Notificação</Title>
      <InputWrapper>
        <h4>Título da Notificação</h4>
        <Input
          placeholder="Digite um título para a notificação"
          value={notification.titulo}
          onChange={(e) => setNotification({ ...notification, titulo: e.target.value })}
        />
      </InputWrapper>
      <InputWrapper>
        <h4>Alvo da Notificação</h4>
        <MultiSelectWithOption
          placeholder="Selecione uma ou mais opções"
          onChange={(values) => setNotification({ ...notification, usersType: values })}
          values={notification.usersType}
          options={[
            { label: 'Administrador', value: 'admin' },
            { label: 'Gestor', value: 'gestor' },
          ]}
          valueKey="value"
          labelKey="label"
        />
      </InputWrapper>
      <InputWrapper>
        <h4>Texto da Notificação</h4>
        <Input.TextArea
          placeholder="Cole aqui o texto que será apresentado"
          value={notification.mensagem}
          rows={20}
          onChange={(e) => setNotification({ ...notification, mensagem: e.target.value })}
        />
        <InputInfo>
          Utilizar o{' '}
          <a
            href="https://onlinehtmleditor.dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://onlinehtmleditor.dev
          </a>{' '}
          como fonte.
        </InputInfo>
      </InputWrapper>
      <ActionButton>
        <Button onClick={() => onPreview(notification)}>Preview</Button>
        <Button
          disabled={loading || !canCreate()}
          type="primary"
          onClick={create}
        >
          Enviar Notificação
        </Button>
      </ActionButton>
    </>
  );
}

CreateNotification.propTypes = {
  onPreview: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default CreateNotification;
